import React, { Fragment } from "react";
import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeGA4Client } from "../../lib/analytics/ga4";

export function useCoalitionSpaceAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "coalitionspace",
        },
      });

      analytics.addClient(ga4Client);
    }
  }, [config.environment, analytics]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
  },
  staging: {
    ga4TrackingId: "G-BPYSBEPNHP",
  },
  production: {
    ga4TrackingId: "G-RCM2ZGLVDD",
  },
};

export default function CoalitionSpaceAnalytics(): JSX.Element {
  useCoalitionSpaceAnalytics();

  return <Fragment></Fragment>;
}
